import { render } from "./quotation-chart.vue?vue&type=template&id=f2cae4ce"
import script from "./quotation-chart.vue?vue&type=script&lang=js"
export * from "./quotation-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__